<template>
  <v-container grid-list-xs class="pa-0 ma-0 px-2" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <v-btn icon color="primary" @click="onVolver()">
          <v-icon>mdi-arrow-left-bold-circle</v-icon>
        </v-btn>
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          v-if="this.$store.state.token!=''"
          :tabla="TablaName"
          :bActiveFilter="false"
          :bActiveExport="false"
          :bSingleSelect="false"
          :bShowSelect="false"
          :bShowMapDetails="false"
          :bActiveNew="false"
          @onBtnGenerico="onAccionEvento"
          :bGridAnidada="false"
          :aAccionesAdicionales="aAccionesAdicionales"
          :aParametros="aParametrosAdicionalesObs"
          >
        >
        </grid>  
        <EditarLicencias ref="refDialog" @onConfirm="onConfirm"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
import EditarLicencias from '@/views/Licencias/components/EditarLicencias.vue'
// import DialogFirmas from '@/components/DialogFirmas.vue' 

export default {
  name: 'EditarLicenciasCliente',
  components: {
    grid,
    EditarLicencias
  },
  mixins: [mxFunciones],
  data() {
    return {
      TablaName : 'VLicenciasConfiguracion',    // Nombre de la tabla a trabajar
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: "Control de licencias",
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: '',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      aAccionesAdicionales: [
        {
          componente: 'BtnGenerico',
          mensaje: 'Editar Licencia',
          oProps: {
            iconname:'mdi-pencil',
            sNombre:'onEditarLicencias'
          }
        }
      ],
      aParametrosAdicionalesObs:[],
      sSubdominio:""
    }
  },
  async mounted() {
    this.onValidarTokenSinLogin()
    this.tituloGrids = await this.getTitulo(this.TablaName)
    this.aItemsBreadcrumbs[2].text = this.tituloGrids
    this.sSubdominio = this.$route?.params?.id;
    this.aParametrosAdicionalesObs = ["sSubdominio="+this.sSubdominio]
  },
  methods: {
    onVolver(){
      this.$router.push({ name: 'AdministracionLicencias'});
    },
    onAccionEvento(oItem, sAccion){
      if(sAccion === 'onEditarLicencias'){
        this.$refs["refDialog"].bDialog = true;
        oItem["sSubdominio"]=this.sSubdominio;
        this.$refs["refDialog"].oItem = oItem;
        this.$refs["refDialog"].nLicencias = oItem?.Licencias || 0;
      }
    },
    onConfirm(){
      location.reload();
    }
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>

</style>